exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3UdkeQUSTNy2VyW7bXwU3q li {\n    margin-bottom: 12px;\n}\n\n._1xSoc6ONPj3-OPxwwlz5Tf {\n    margin-bottom: 12px;\n}\n\nul {\n    margin: 0;\n    padding-left: 32px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "_3UdkeQUSTNy2VyW7bXwU3q",
	"subtitle": "_1xSoc6ONPj3-OPxwwlz5Tf"
};